import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';

const MetaData = ({ titleDate, metaDate }) => (
    <Helmet
        title={`Latest Going & Non Runners | ${titleDate} | Racing Post`}
        meta={[
            {
                name: 'description',
                content: `Latest going and Non Runners, ${metaDate}, courtesy of the Racing Post`,
            },
        ]}
    />
);

MetaData.propTypes = {
    titleDate: PropTypes.string.isRequired,
    metaDate: PropTypes.string.isRequired,
};

export default MetaData;




// WEBPACK FOOTER //
// ./src/js/nonRunners/components/MetaData.jsx